export default "__VITE_ASSET__bcc2c560__"